import { Injectable } from '@angular/core';
import { ErrorNumber } from '../constants-types';
import { TranslationService } from '../translations';
import { StringUtilities } from './../core-utilities/String.utility';
import { NotificationService } from './Notifications.service';

@Injectable({ providedIn: 'root' })
export class CustomNotificationService {
    customErrorToString: {
        [key: number]: {
            title: string;
            message: (propertyName: string) => string;
        };
    } = {
        [ErrorNumber.MaxCognitiveAssessmentsPerEmailReached]: {
            title: this.TR.key('notification.error-genericTitle'),
            message: (propertyName: string) =>
                this.stringUtil.formatString(
                    this.TR.key('error.MaxCognitiveAssessmentsPerEmailReached'),
                    propertyName
                )
        }
        // Add future custom error messages here
    };

    constructor(
        private notificationService: NotificationService,
        private TR: TranslationService,
        private stringUtil: StringUtilities
    ) {}

    /**
     * Throws a custom error message with the ability to add a propertyName that can be inserted
     * into the error message for more clear messaging on who or what the issues is related to
     *
     * @param errorNumber Error Number
     * @param propertyName Property that can be passed into the custom message body (ie. surveyUser Email or jobTitle)
     * @param overrideTitle Override error toast title translation key
     * @param overrideMessage Override error toast message translation key
     */
    pushCustomError(
        errorNumber?: number,
        propertyName?: any,
        overrideTitle?: string,
        overrideMessage?: string
    ) {
        if (this.customErrorToString[errorNumber]) {
            const customError = this.customErrorToString[errorNumber];
            const customMessage = propertyName
                ? customError.message(propertyName)
                : this.TR.key('notification.error-genericMessage');
            this.notificationService.pushError(
                customError.title,
                customMessage
            );
        } else {
            const errorTitle =
                overrideTitle || 'notification.error-genericTitle';
            const errorMessage =
                overrideMessage || 'notification.error-genericMessage';
            this.notificationService.pushError(
                this.TR.key(errorTitle),
                this.TR.key(errorMessage)
            );
        }
    }
}
